import React, { FC, useState } from "react";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { saveAs } from "file-saver";
import VideocamIcon from "@material-ui/icons/Videocam";

interface IDownloadVideo {
  video: string;
  margin?: string;
}

const getVideoFilename = (url: string) => {
  try {
    const path = decodeURIComponent(new URL(url).pathname);
    const name = path.substring(path.lastIndexOf("/") + 1);
    if (name && name.includes(".")) return name;
    return (name || "video") + ".mp4";
  } catch (error) {
    return "video.mp4";
  }
};

const DownloadVideo: FC<IDownloadVideo> = ({ video, margin = "" }) => {
  const [loading, setLoading] = useState(false);

  const isDownloadable =
    !!video && (video.includes("firebasestorage") || video.includes("dropbox"));

  if (!isDownloadable) return null;

  const handleDownload = async () => {
    if (video.includes("dropbox")) {
      // dl=1 makes Dropbox serve the file as a direct download
      window.open(video.split("?")[0] + "?dl=1", "_blank");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(video);
      const blob = await response.blob();
      saveAs(blob, getVideoFilename(video));
    } catch (error) {
      window.open(video, "_blank");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "10px 15px",
        margin: margin,
      }}
    >
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <Tooltip title="Download video" arrow>
          <VideocamIcon
            style={{
              cursor: "pointer",
              height: 19,
              width: 19,
            }}
            onClick={handleDownload}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default DownloadVideo;
